import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!user) return null;

  return (
    <nav className="bg-slate-800 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="text-xl font-bold text-white">
              <span className="text-blue-400">Chart</span>Audit AI
            </Link>
            <div className="flex space-x-4">
              <Link to="/" className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                Dashboard
              </Link>
              <Link to="/upload" className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                Upload & Audit
              </Link>
              <Link to="/audits" className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium">
                Audit History
              </Link>
              {user.role === 'super_admin' && (
                <Link to="/admin" className="text-yellow-400 hover:text-yellow-300 px-3 py-2 rounded-md text-sm font-medium">
                  Admin
                </Link>
              )}
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <div className="text-right">
              <span className="text-gray-300 text-sm block">{user.firstName} {user.lastName}</span>
              <span className="text-gray-500 text-xs">{user.agencyName}
                {user.accountType === 'consultant' && (
                  <span className="ml-1 text-purple-400">(Consultant)</span>
                )}
              </span>
            </div>
            <button onClick={handleLogout}
              className="bg-red-600 hover:bg-red-700 px-3 py-1.5 rounded text-sm font-medium">
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
